export default {
  getResources(state) {
    return state.resources
  },
  getResourceGroups(state) {
    return state.resourceGroups
  },
  getCatalog(state) {
    
    return state.catalog
  },
  getMesurements(state) {
    return state.measurements
  },
}